export const GET_ALERTS_LIST = 'VARUNA.GET_ALERTS_LIST'
export const SEARCH_ALERTS = 'VARUNA.SEARCH_ALERTS'
